import {Route, Routes, useLocation} from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import React, {useEffect} from "react";
import AuthLayout from "../layouts/auth-layout/AuthLayout";
import Login from "../views/auth/signin/Login";
import ForgotPassword from "../views/auth/signin/ForgotPassword";
import OtpVerificationScreen from "../views/auth/signin/OtpVerificationScreen";
import ChangePassword from "../views/auth/signin/ChangePassword";
import Signup from "../views/auth/signup/Signup";
import AccountCreated from "../views/auth/signup/account-created/AccountCreated";
import AccountSetup from "../views/auth/account-setup/AccountSetup";
import Home from "../views/dashboard/home/Home";
import Vault from "../views/dashboard/vault/Vault";
import VaultDetails from "../views/dashboard/vault/vault-pages/VaultDetails";
import Journals from "../views/dashboard/journals/Journals";
import JournalDetails from "../views/dashboard/journals/journal-pages/JournalDetails";
import EditJournals from "../views/dashboard/journals/journal-pages/EditJournals";
import TermsAndConditionSetting from "../views/dashboard/settings/pages/TermsAndConditionSetting";
import Settings from "../views/dashboard/settings/Settings";
import ChangePasswordSetting from "../views/dashboard/settings/change-password/ChangePasswordSetting";
import PrivacyPolicySetting from "../views/dashboard/settings/pages/PrivacyPolicySetting";
import Faqs from "../views/dashboard/settings/faqs/Faqs";
import ProtectedRoute from "./ProtectedRoute";
import UnauthorizedRoute from "./UnauthorizedRoute";
import MyProfile from "../views/dashboard/my-profile/MyProfile";
import ValidateJournalPassword from "../views/dashboard/journals/journal-pages/ValidateJournalPassword";
import ResetJournalPassword from "../views/dashboard/journals/journal-pages/ResetJournalPassword";
import EditProfileSkeleton from "../views/skeletons/my-profile/edit-pages/EditProfileSkeleton";
import GratitudeListing from "../views/dashboard/gratitude/GratitudeListing";
import Archive from "../views/dashboard/home/pillars/archieves/Archive";
import SetJournalPassword from "../views/dashboard/journals/journal-pages/SetJournalPassword";
import JournalOtpScreen from "../views/dashboard/journals/journal-pages/JournalOtpScreen";
import Forum from "../views/dashboard/forum/Forum";
import Dashcoaching from "../views/dashboard/dashboard-coach/Dashcoaching";
import ValidateForumPassword from "../views/dashboard/forum/ValidateForumPassword";
import UserProfile from "../views/dashboard/forum/UserProfile";
import ClientDetails from "../views/dashboard/dashboard-coach/ClientDetails";
import AddNote from "../views/dashboard/dashboard-coach/AddNote";
import NoteDetails from "../views/dashboard/dashboard-coach/NoteDetails";
import EditNote from "../views/dashboard/dashboard-coach/EditNote";
import Quest from "../views/dashboard/goals/Quest";
import Courses from "../views/dashboard/courses/Courses";
import CourseDetails from "../views/dashboard/courses/courses-details/CourseDetails";
import CourseVideoDetails from "../views/dashboard/courses/courses-details/CourseVideoDetails";

function RouteConfig() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Routes>
      <Route
        element={
          <ProtectedRoute>
            <DashboardLayout></DashboardLayout>
          </ProtectedRoute>
        }
      >
        <Route path={"/"} element={<Home />}></Route>
        <Route path={"/vault"} element={<Vault />}></Route>
        <Route path={"/vault/details/:id"} element={<VaultDetails />}></Route>
        <Route path={"/journals"} element={<Journals />}></Route>
        <Route path={"/coaching"} element={<Dashcoaching />}></Route>
        <Route path={"/courses"} element={<Courses />}></Route>
        <Route path={"/courses/:id"} element={<CourseDetails />}></Route>
        <Route path={"/courses/:courseId/videos/:videoId"} element={<CourseVideoDetails />}></Route>
        <Route
          path={"/coaching/client-details/:id"}
          element={<ClientDetails />}
        ></Route>
        <Route
            path={"/coaching/add-note/:id"}
            element={<AddNote/>}
        ></Route>
        <Route
            path={"/coaching/edit-note/:id"}
            element={<EditNote/>}
        ></Route>
        <Route
            path={"/coaching/note-details/:id"}
            element={<NoteDetails/>}
        ></Route>
        <Route path={"/forum"} element={<Forum />}></Route>
        <Route
          path={"/forum/user-profile/:id"}
          element={<UserProfile />}
        ></Route>
        <Route
          path={"/journals/details/:id"}
          element={<JournalDetails />}
        ></Route>
        <Route path={"/journals/edit/:id"} element={<EditJournals />}></Route>
        <Route path={"/my-profile"} element={<MyProfile />}></Route>
        <Route
          path={"/journals/validate-password"}
          element={<ValidateJournalPassword />}
        ></Route>
        <Route
          path={"/forum/validate-password"}
          element={<ValidateForumPassword />}
        ></Route>
        <Route
          path={"/journals/set-journal-password"}
          element={<SetJournalPassword />}
        ></Route>
        <Route
          path={"/journals/reset-password"}
          element={<ResetJournalPassword />}
        ></Route>
        <Route
          path={"/journals/journal-otp-screen"}
          element={<JournalOtpScreen />}
        ></Route>
        <Route
            path={"/quests"}
            element={<Quest />}
        ></Route>
        <Route path={"/testing"} element={<EditProfileSkeleton />}></Route>
        <Route path={"/gratitude"} element={<GratitudeListing />}></Route>
        <Route path={"/pillar/archives"} element={<Archive />}></Route>

        <Route element={<Settings />}>
          {/* Nested routes within SettingLayout */}
          <Route
            path="/settings/change-password"
            element={<ChangePasswordSetting />}
          />
          <Route
            path="/settings/terms-and-conditions"
            element={<TermsAndConditionSetting />}
          />
          <Route
            path="/settings/privacy-policy"
            element={<PrivacyPolicySetting />}
          />
          <Route path="/settings/faqs" element={<Faqs />} />
          {/* Default route at the end */}
        </Route>
      </Route>

      {/*<Route*/}
      {/*    path="/account-setup"*/}
      {/*    element={*/}
      {/*        // <UnauthorizedRoute roles={["artist", "fan", "vanue"]}>*/}
      {/*        <AccountLayout/>*/}
      {/*        // </UnauthorizedRoute>*/}

      {/*    }*/}
      {/*/>*/}

      {/*<Route*/}
      {/*    element={*/}
      {/*            <AuthLayout/>*/}
      {/*    }*/}
      {/*>*/}
      {/*    <Route path={'role-selection'} element={<RoleSelection/>}></Route>*/}
      {/*    <Route path={'subscription'} element={<Subscription/>}></Route>*/}
      {/*</Route>*/}

      <Route
        element={
          <UnauthorizedRoute>
            <AuthLayout />
          </UnauthorizedRoute>
        }
      >
        <Route path="/login" element={<Login />} />
        <Route path={"forgot-password"} element={<ForgotPassword />}></Route>
        <Route
          path={"otp-verfication-password"}
          element={<OtpVerificationScreen />}
        ></Route>
        <Route path={"change-password"} element={<ChangePassword />}></Route>
        <Route path={"signup"} element={<Signup />}></Route>
        <Route path={"account-created"} element={<AccountCreated />}></Route>
        <Route path={"account-setup"} element={<AccountSetup />}></Route>
      </Route>
    </Routes>
  );
}

export default RouteConfig;
